hp(window).on('load', (e) => {
    const TRANSFER_MODAL = hp('#site-transfer-modal');
    const TRANSFER_BTNS = TRANSFER_MODAL.find('input[name="type-of-transfer"]')
    const ACCESS_BLOCK = TRANSFER_MODAL.find('.access-data')
    const FORM = TRANSFER_MODAL.find('.site-transfer-form')
    const SUBMIT_BTN = FORM.find('button[type="submit"]')
    const ERROR_BLOCK = hp('.error-block');

    let transferType = 'hoster-trans';

    TRANSFER_BTNS.on('change', (e) => {
        let selectedType = hp(e.target)

        transferType = selectedType.val()

        if (transferType == 'hoster-trans') {
            ACCESS_BLOCK.addClass('active')

            return;
        }

        ACCESS_BLOCK.removeClass('active')
    })

    let beforeSend = (data) => {
        SUBMIT_BTN.prop('disabled', true)
    }

    let successFunc = (res) => {
        ERROR_BLOCK.addClass('d-none')

        if (!('status' in res)) {
            return;
        }

        if ('redirect' in res) {
            location.href = res.redirect
        }

        if ('status' in res && res.status == 'fail') {
            errorFunc(res)
        }
    }

    let errorFunc = (res) => {
        if (res.status == 'fail' && 'answer' in res) {
            let alertBlock = ERROR_BLOCK.find('.alert')
            alertBlock.html('')
            alertBlock.text(res.answer)
        }

        if (res.status == 'fail' && 'inputs' in res) {
            let alertBlock = ERROR_BLOCK.find('.alert')
            alertBlock.html('<ul class="mb-0"></ul>')
            alertBlock = alertBlock.find('ul')

            let inputs = '';

            for (const [inputName, inputError] of Object.entries(res.inputs)) {
                inputs += `<li>${inputError}</li>`
            }

            alertBlock.html(inputs)

            ERROR_BLOCK.removeClass('d-none')
        }
    }

    let completeFunc = (res) => {
        SUBMIT_BTN.removeAttr('disabled')
        refreshReCaptchaV3('site_transfer_action_id', 'site_transfer_action');
    }

    FORM.on('submit', (e) => {
        e.preventDefault()

        let data = {
            name: FORM.find('#name').val(),
            email: FORM.find('[name="email"]').val(),
            'type-of-transfer': transferType,
            'control-panel-link': FORM.find('#access').val(),
            'comments-for-trans': FORM.find('#comments-for-trans').val(),
            'g-recaptcha-response': getReCaptchaV3Response('site_transfer_action_id')
        };

        if (transferType == 'hoster-trans') {
            data.login = FORM.find('#login').val();
            data.password = FORM.find('#password').val();
        }

        beforeSend(data)

        fetch('/send/site-transfer', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': hp('meta[name="csrf-token"]').attr('content')
            },
        }).then(res => {
            try {
                let temp = res.json();
                errorFunc(temp)
                completeFunc(res);


                return temp
            } catch (error) {
                return { status: 'error' }
            }
        }).then(result => {
            if (result.status == 'fail' || result.status == 'error') {
                errorFunc(result);
                completeFunc(result);
                return;
            }

            successFunc(result);

            completeFunc(result);
        })
    });
});
